<template>
    <a-cascader
            change-on-select
            v-model="selectArr"
            :options="options"
            @change="onChange"
            :fieldNames="{ label: 'name', value: 'value', children: 'children' }"
            placeholder="所属区域"
    >
    </a-cascader>
</template>

<script>

    import {getRegionTree} from '../../../api/api'
    import mixin from '../mixin/AExtStringMixin'
    export default {
        name: "index.vue",
        mixins:[mixin],
        props:{
          level:{
              type:String,
              default:''
          },
        },
        data() {
            return {
                selectArr:[],
                options:[],
                localValue:''
            }
        },
        created(){
            this.init();
        },
        methods:{
            init(){
                let windowHas=false;
                let param=''
                switch (this.level) {
                    case '省市区':
                        param='\'province\',\'city\',\'county\''
                        if(window.ssq)
                        {
                            this.options=window.ssq;
                            windowHas=true;
                        }
                        break;
                    case '省市':
                        param='\'province\',\'city\''
                        if(window.ss)
                        {
                            this.options=window.ss;
                            windowHas=true;
                        }
                        break;
                    case '市区':
                        param='\'city\',\'county\''
                        if(window.sq)
                        {
                            this.options=window.sq;
                            windowHas=true;
                        }
                        break;
                    default:
                        if(window.ssq)
                        {
                            this.options=window.ssq;
                            windowHas=true;
                        }
                        param='\'province\',\'city\',\'county\''
                }
                //TODO: 根据levelStr查询省市区
                if(!windowHas) {
                    getRegionTree(param).then(result => {
                        if (result.data && result.data.succ) {
                            this.options = result.data.data;
                            this.selectArr=[];
                            this.selectArr.push(this.localValue)
                            this.getSelectArrByCode(this.localValue);
                        }
                    }).catch(() => {

                    })
                }
                else {
                    this.selectArr=[];
                    this.selectArr.push(this.localValue)
                    this.getSelectArrByCode(this.localValue);
                }
            },
            onChange (e, selectedOptions) {
                if(selectedOptions) {
                    this.selectArr = selectedOptions.map((o) => o.path);
                    this.localValue = selectedOptions[selectedOptions.length - 1].value;
                }
                else {
                    this.selectArr=[];
                    this.localValue='';
                }
            },
            getSelectArrByCode(path){
                console.log('getSelectArrByCode',path)
                let ppath=this.getParentCodeByCode(path,this.options);
                let pppath=this.getParentCodeByCode(ppath,this.options);
                console.log('getSelectArrByCode2',ppath)
                if(ppath&&pppath) {
                    this.selectArr.unshift(ppath);
                    this.getSelectArrByCode(ppath);
                }
            },
            getParentCodeByCode(path,arr){
                let ppath=null;
                for (let i=0;i<arr.length;i++)
                {
                    if (arr[i].path&&arr[i].path===path)
                        return arr[i].ppath;
                    if(arr[i].children&&arr[i].children.length)
                    {
                        ppath=this.getParentCodeByCode(path,arr[i].children);
                        if(ppath)
                        {
                            return ppath;
                        }
                    }
                }
                return ppath;
            }
        }
    }
</script>

<style scoped>

</style>